import React from "react";
import { GiCutDiamond } from "react-icons/gi";

const tags = [
  "Bridal Sets", "Hallmark 916", "Kundan Meena", "Antique Gold",
  "Mangalsutra", "Temple Jewellery", "Kutchi Craft", "Gold Watches",
  "Silver Payal", "Custom Designs",
];

export default function TagMarquee() {
  const strip = (k) => (
    <div className="flex shrink-0 items-center" key={k}>
      {tags.map((t, i) => (
        <span key={i} className="flex items-center gap-5 whitespace-nowrap px-5 font-display text-xl text-coffee-700/80">
          {t}
          <GiCutDiamond className="text-gold" />
        </span>
      ))}
    </div>
  );
  return (
    <div className="paused overflow-hidden border-y border-gold/30 bg-cream/70 py-4">
      <div className="flex w-max animate-marquee-slow anim-marquee">
        {strip("a")}
        {strip("b")}
      </div>
    </div>
  );
}
